export function initLogin() {
  const CORRECT_PASSWORD = "f@24634565*340@f";

  const form = document.getElementById("loginForm") as HTMLFormElement | null;
  const errorText = document.getElementById("error") as HTMLElement | null;
  const loginScreen = document.getElementById("login-screen") as HTMLElement | null;
  const loreScreen = document.getElementById("lore-screen") as HTMLElement | null;

  const entryButtons = document.querySelectorAll<HTMLButtonElement>("[data-entry-target]");
  const loreList = document.getElementById("lore-list");
  const loreDetail = document.getElementById("lore-detail");
  const entryTitle = document.getElementById("entry-title");
  const entryText = document.getElementById("entry-text");
  const backButton = document.getElementById("entry-back");

  if (!form || !errorText || !loginScreen || !loreScreen) {
    throw new Error("Error");
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    const password = formData.get("password");

    if (password === CORRECT_PASSWORD) {
      loginScreen.classList.add("hidden");
      loreScreen.classList.remove("hidden");
      errorText.classList.add("hidden");
      form.reset();
    } else {
      errorText.classList.remove("hidden");
    }
  });

  if (!loreList || !loreDetail || !entryTitle || !entryText || !backButton) {
    return;
  }

  entryButtons.forEach((btn) => {
    const targetId = btn.dataset.entryTarget;
    if (!targetId) return;

    const panel = document.getElementById(targetId);
    if (!panel) return;

    btn.addEventListener("click", () => {
      const title = btn.dataset.entryTitle ?? btn.textContent?.trim() ?? "";

      entryTitle.textContent = title;
      entryText.innerHTML = panel.innerHTML; 

      loreList.classList.add("hidden");
      loreDetail.classList.remove("hidden");
    });
  });

  backButton.addEventListener("click", () => {
    loreDetail.classList.add("hidden");
    loreList.classList.remove("hidden");
  });
}
